"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DragonsBreathAbilityHandler = exports.DragonsBreathActorAbilityFactory = exports.DragonsBreathAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const Random_1 = require("../../utils/Random");
const enums_1 = require("../../core/enums");
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/effects/core");
const AbilityDamage_1 = require("../../core/AbilityDamage");
class DragonsBreathAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.DragonsBreath;
        this.__typeName = "DragonsBreath";
    }
}
exports.DragonsBreathAbilityArgs = DragonsBreathAbilityArgs;
let DragonsBreathActorAbilityFactory = class DragonsBreathActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("DragonsBreath", "AllEnemies", 0);
    }
};
DragonsBreathActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("DragonsBreath")
], DragonsBreathActorAbilityFactory);
exports.DragonsBreathActorAbilityFactory = DragonsBreathActorAbilityFactory;
let DragonsBreathAbilityHandler = class DragonsBreathAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const targets = container.selectLivingTargets(ability.invokerId, Target_1.Target.AllEnemies);
        container.applyMultiAttack({
            abilityKey: ability.args.__typeName,
            attackType: "magic",
            attackerId: ability.invokerId,
            sequence,
            targets: targets.map((targetId, i) => ({
                targetId,
                jitter: (0, Random_1.random)(25, 75),
                damages: [
                    AbilityDamage_1.AbilityDamage.Focus("Fire", 50)
                ],
                effects: [
                    {
                        targetId,
                        duration: Duration_1.Duration.Turns(2),
                        effect: new core_1.LinkedEffectsEffectArgs([
                            new core_1.MaxAttributeDecreaseEffectArgs(enums_1.AttributeType.FireDamageImmunity, 10),
                            new core_1.MaxAttributeDecreaseEffectArgs(enums_1.AttributeType.AllDamageResistance, 10)
                        ], true)
                    }
                ]
            }))
        });
    }
};
DragonsBreathAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.DragonsBreath)
], DragonsBreathAbilityHandler);
exports.DragonsBreathAbilityHandler = DragonsBreathAbilityHandler;
